module.exports = __webpack_public_path__ + "img/uploadbanner.64e6c0a1.svg";